import React from "react";
import PolicyLayout from "./PolicyLayout";
import { SITE_CONFIG } from "../config/siteConfig";

function InternationalOrders() {
  return (
    <PolicyLayout
      title="International orders and customs policy"
      intro={`This policy applies when the selected delivery destination is outside ${SITE_CONFIG.operatingRegion}.`}
    >
      <section>
        <h2>Destination eligibility</h2>
        <p>Only countries and regions offered in checkout can receive an order. Availability of a country selector does not override the destination's rules for food, beverages, alcohol, electrical goods, plant motifs, product materials or personal import quantities. The buyer must confirm that the ordered goods can lawfully enter and be received at the destination.</p>
      </section>

      <section>
        <h2>Customs information and charges</h2>
        <p>Destination authorities or delivery intermediaries may request recipient identification, product information, duties, taxes or clearance charges. Those destination assessments are separate from the {SITE_CONFIG.currency} merchandise total and fixed checkout shipping charge. The recipient is responsible for charges lawfully imposed for import and for answering clearance requests accurately.</p>
      </section>

      <section>
        <h2>Restricted and age-controlled products</h2>
        <p>Spirits are supplied only where cross-border sale, import and delivery to the intended recipient are lawful. Age evidence may be required at payment review, clearance or handover. Food and drink labels must be checked for destination ingredient, allergen and labelling requirements. An order or affected line can be cancelled where lawful import cannot be established.</p>
      </section>

      <section>
        <h2>Clearance failure and return</h2>
        <p>If the recipient does not complete a required clearance or lawful receipt step, the parcel may be held, returned or disposed of under the destination process. We review the actual parcel outcome and evidenced charges before determining any refund. An amount retained must correspond to an established cost or legal restriction; mandatory rights for seller error or misdescription remain unaffected.</p>
      </section>

      <section>
        <h2>Transit problems</h2>
        <p>For a missing or damaged international parcel, use the same order-number, label, packaging and photograph process described in the delivery problems policy. Do not send identity or customs documents by ordinary email unless support has confirmed why they are required and a suitable method.</p>
      </section>
    </PolicyLayout>
  );
}

export default InternationalOrders;
